import {Injectable, inject, signal} from '@angular/core';
import {Subject} from 'rxjs';
import {SupportApiService} from '../../common/services/api/routes/support-api.service';

/**
 * How many requests have an answer the account has not read: the number on
 * the dashboard's Support entry. Asked when the dashboard opens and when a
 * reply notification arrives; the Support pages set it from what they load.
 */
@Injectable({
  providedIn: 'root',
})
export class SupportBadgeService {
  private supportApi = inject(SupportApiService);

  readonly count = signal(0);
  /** A request support has just answered (its id): an open conversation reloads. */
  readonly replies$ = new Subject<string>();

  set(count: number) {
    this.count.set(Math.max(0, count || 0));
  }

  refresh() {
    this.supportApi.unreadCount().then(r => this.set(r.count)).catch(() => undefined);
  }

  /** A reply notification arrived (NotificationsService). */
  replied(ticketId: string) {
    this.refresh();
    if (ticketId) {
      this.replies$.next(ticketId);
    }
  }
}
